import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteArguments {
  params: OpalApiRequestParams<'DeleteBlockCustomFieldValueV3'>
}

export async function deleteBlockCustomFieldValue({
  params,
}: DeleteArguments): Promise<null> {
  const url = new URL(
    `loupe/v3/block_custom_field_values/${params.path.block_custom_field_value_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
